import React from 'react';
import {
    Create,
    BooleanInput,
    email,
    required,
    SimpleForm,
    TextInput
} from 'react-admin';

export const UserCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput label="Username" validate={ required() } source="username" />
            <TextInput label="First Name" validate={ required() } source="first_name" />
            <TextInput label="Last Name" validate={ required() } source="last_name" />
            <TextInput label="Email" type="email" validate={ [email(), required()] } source="email" />
            <TextInput label="Password" type="password" validate={ required() } source="plain_password" />
            <BooleanInput label="Claimed?" source="claimed" />
            <BooleanInput label="Enabled?" source="enabled" />
            <BooleanInput label="Opted In?" source="opted_in" />
        </SimpleForm>
    </Create>
)
